// The summary on the page of a project (R-E8, decision 040 п.7): the numbers over all its events, counted on the server by the analytics
// API (R-AN2). Which numbers — the setting «Числа сводки» of the project (by default the first four of the catalog), changed right here.
import { useState } from 'react';
import { resolveSetting } from '@confdeck/core-shared';
import { Button, MetricTiles, RecordSettings, useCatalog, useMeta, useSync } from '@confdeck/core-web';
import s from './conferences.module.css';

export const SUMMARY_KEY = 'project.summary';

export function ProjectSummary({ recordId }: { recordId: string }) {
  const client = useSync();
  const meta = useMeta();
  const { catalog, error } = useCatalog();
  const [choosing, setChoosing] = useState(false);
  const d = client.header?.settings?.find((x) => x.key === SUMMARY_KEY);
  if (!d) return null;
  const keys = String(resolveSetting(meta, d, null, null, [recordId]).value).split(',').filter(Boolean);
  // Only the numbers the person may see: a metric of sections they do not read is not in their catalog.
  const metrics = keys.map((k) => catalog?.metrics.find((m) => m.key === k)).filter((m) => !!m);
  return (
    <div className={s.summary}>
      {error ? <p className={s.tplHint} role="alert">{error}</p> : catalog && <MetricTiles metrics={metrics} scope={recordId} period="all" label="Сводка проекта" />}
      <div className={s.summaryFoot}>
        <span className={s.tplHint}>По всем событиям проекта, за всё время.</span>
        <Button size="sm" variant="ghost" icon="settings" onClick={() => setChoosing((x) => !x)}>{choosing ? 'Готово' : 'Выбрать числа'}</Button>
      </div>
      {choosing && <RecordSettings recordId={recordId} groups={['Сводка']} />}
    </div>
  );
}
